import { RolodexEntryTagsType, RolodexEntryType } from 'types'

/**
 * Typed accessor for the ubiquitous "string tag or absent" read. Rolodex tag
 * values are loosely typed (string | null | other shapes), which pushed call
 * sites into repeating `tags[X] as string | undefined` casts -- this helper
 * ends the pattern. Empty strings normalize to `undefined` (matching the
 * `|| undefined` idiom the casts were paired with).
 */
export function getStringTag(
  tags: RolodexEntryTagsType,
  key: RolodexEntryType
): string | undefined {
  const value = tags[key]
  return typeof value === 'string' && value !== '' ? value : undefined
}
